import Context from './Context.js';

export default class Campaign extends Context {
  constructor(source, medium, campaign, term, content) {
    super();
    this.data = {
      ca_so: source,
      ca_me: medium,
      ca_id: campaign,
      ca_te: term,
      ca_co: content
    };
  }

  static get key() {
    return 'campaign_event_context'
  }
}
